import axios from 'axios';

const Api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cache: 'no-cache',
    frontend: true,
  },
  withCredentials: true,
});

export default Api;
